module.exports = __webpack_public_path__ + "static/media/ar3.adca03c5.jpg";